<template>
  <a-modal
    :title="formTitle || '处理反馈'"
    :visible="open"
    @update:visible="(val) => { open = val }"
    @cancel="cancel"
    :width="600"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form 
      ref="formRef" 
      :model="form" 
      :rules="rules"
      :label-col="{ flex: '0 0 100px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
    >
      <!--      <a-form-item label="用户id，外键{user.id}" name="userId" >-->
      <!--        <a-input v-model:value="form.userId" placeholder="请输入用户id，外键{user.id}" />-->
      <!--      </a-form-item>-->
      <!--      <a-form-item label="反馈类型：1-意见建议、2-故障报告、3-投诉" name="type" >-->
      <!--      </a-form-item>-->
      <!--      <a-form-item label="反馈内容" name="content" >-->
      <!--        <editor v-model:value="form.content" />-->
      <!--      </a-form-item>-->
      <a-form-item label="处理状态" name="processStatus">
        <a-select
          v-model:value="form.processStatus"
          placeholder="请选择处理状态"
          style="width: 100%"
        >
          <a-select-option :key="1">待处理</a-select-option>
          <a-select-option :key="2">已处理</a-select-option>
          <a-select-option :key="3">暂不处理</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="处理结果" name="processResult">
        <!--        <a-input v-model:value="form.processResult" placeholder="请输入处理结果" />-->
        <a-textarea
          v-model:value="form.processResult"
          placeholder="请输入处理结果"
          :rows="4"
        />
      </a-form-item>
      <!--      <a-form-item label="反馈图片地址集合,JSONArray的字符串" name="imgUrls" >-->
      <!--        <a-input v-model:value="form.imgUrls" placeholder="请输入反馈图片地址集合,JSONArray的字符串" />-->
      <!--      </a-form-item>-->
      <!--      <a-form-item label="联系方式" name="contact" >-->
      <!--        <a-input v-model:value="form.contact" placeholder="请输入联系方式" />-->
      <!--      </a-form-item>-->
      <!--      <a-form-item label="备注" name="remark" >-->
      <!--        <a-input v-model:value="form.remark" placeholder="请输入备注" />-->
      <!--      </a-form-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { getFeedback, addFeedback, updateFeedback } from '@/api/app/feedback'
import Editor from '@/components/Editor'

const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)

const form = reactive({
  id: null,
  userId: null,
  type: null,
  content: null,
  processStatus: 0,
  processResult: null,
  imgUrls: null,
  contact: null,
  remark: null,
  createTime: null,
})

const rules = {
  userId: [
    {
      required: true,
      message: '用户id，外键{user.id}不能为空',
      trigger: 'blur',
    },
  ],
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    userId: null,
    type: null,
    content: null,
    processStatus: 0,
    processResult: null,
    imgUrls: null,
    contact: null,
    remark: null,
    createTime: null,
  })
  nextTick(() => {
    if (formRef.value) {
      formRef.value.resetFields()
    }
  })
}

function handleAdd(row) {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '添加'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getFeedback({ id: id }).then((response) => {
    Object.assign(form, response.data)
    open.value = true
    formTitle.value = '处理'
  })
}

async function submitForm() {
  try {
    await formRef.value.validate()
    submitLoading.value = true
    if (form.id !== undefined && form.id !== null) {
      await updateFeedback(form)
      message.success('修改成功', 3)
      open.value = false
      emit('ok')
    } else {
      await addFeedback(form)
      message.success('新增成功', 3)
      open.value = false
      emit('ok')
    }
  } catch (error) {
    return false
  } finally {
    submitLoading.value = false
  }
}

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>

<style scoped>
.create-form-modal :deep(.ant-modal-body) {
  padding: 24px;
}

.create-form-modal :deep(.ant-form-item-label) {
  text-align: left;
}

.bottom-control {
  margin-top: 24px;
  text-align: right;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.bottom-control .ant-btn {
  min-width: 80px;
}

.bottom-control .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.bottom-control .ant-btn-primary:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}
</style>
